@switch (type()) { @case ('LINE') {
<button
  mat-flat-button
  class="!h-10 w-full !bg-line !px-1.5 shadow-button"
  [ngClass]="{ '!bg-red-600': mode() === 'UNBIND' }"
  (click)="onClick()"
  [attr.data-testid]="'line-login-button'"
>
  <div
    class="flex w-full flex-row text-sm !text-white"
    [attr.data-testid]="'line-button-content'"
  >
    <img
      src="assets/line-white-icon.png"
      alt="line icon"
      class="mx-[5px] h-6 w-6"
      [attr.data-testid]="'line-icon'"
    />
    <div class="flex-1"></div>
    <div class="leading-6" [attr.data-testid]="'line-button-label'">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </div>
    <div class="flex-1"></div>
  </div>
</button>
} @case ('Facebook') {
<button
  mat-flat-button
  class="!h-10 w-full !bg-facebook !px-1.5 shadow-button"
  [ngClass]="{ '!bg-red-600': mode() === 'UNBIND' }"
  (click)="onClick()"
  [attr.data-testid]="'facebook-login-button'"
>
  <div
    class="flex w-full flex-row text-sm !text-white"
    [attr.data-testid]="'facebook-button-content'"
  >
    <icon
      icon="fa-facebook"
      class="mx-[5px] h-6 w-6 !text-[24px]"
      [attr.data-testid]="'facebook-icon'"
    ></icon>
    <div class="flex-1"></div>
    <div class="leading-6" [attr.data-testid]="'facebook-button-label'">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </div>
    <div class="flex-1"></div>
  </div>
</button>
} @case ('Google') { @if (mode() === 'UNBIND') {
<button
  mat-flat-button
  class="!h-10 w-full !bg-red-600 !px-1.5 shadow-button"
  (click)="onClick()"
  [attr.data-testid]="'google-unbind-button'"
>
  <div
    class="flex w-full flex-row text-sm !text-white"
    [attr.data-testid]="'google-button-content'"
  >
    <icon
      icon="./assets/google_white.svg"
      class="mx-[5px]"
      [attr.data-testid]="'google-icon'"
    >
    </icon>
    <div class="flex-1"></div>
    <div class="leading-6" [attr.data-testid]="'google-button-label'">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </div>
    <div class="flex-1"></div>
  </div>
</button>
} @else if (mode() === 'REGISTER') {
<button
  mat-flat-button
  class="!h-10 w-full !bg-red-600 !px-1.5 shadow-button"
  (click)="onClick()"
  [attr.data-testid]="'google-register-button'"
>
  <div
    class="flex w-full flex-row text-sm !text-white"
    [attr.data-testid]="'google-register-content'"
  >
    <icon
      icon="./assets/google_white.svg"
      class="mx-[5px]"
      [attr.data-testid]="'google-register-icon'"
    >
    </icon>
    <div class="flex-1"></div>
    <div class="leading-6" [attr.data-testid]="'google-register-label'">
      <ng-container *ngTemplateOutlet="label"></ng-container>
    </div>
    <div class="flex-1"></div>
  </div>
</button>
<div
  #googleOneTap
  class="button h-[1px] overflow-hidden"
  [ngClass]="{ hidden: mode() === 'UNBIND' }"
  [attr.data-testid]="'google-one-tap-hidden'"
></div>
} @else {
<div
  #googleOneTap
  class="button h-[40px] overflow-hidden"
  [ngClass]="{ hidden: mode() === 'UNBIND' }"
  [attr.data-testid]="'google-one-tap-visible'"
></div>
} } }

<ng-template #label>
  @switch (mode()) { @case ('LOGIN') { 使用 {{ type() }} 登入 } @case ('BIND') {
  綁定 {{ type() }} 登入 } @case ('UNBIND') { 解除 {{ type() }} 綁定 } @case
  ('REGISTER') { 透過 {{ type() }} 註冊 } }
</ng-template>
